import { Attachment } from '@/app/entities/Training'
import { Attachment as AttachmentComponent } from './Attachment'

interface ViewAttachmentsProps {
  attachments: Attachment[]
}

export function ViewAttachments({ attachments }: ViewAttachmentsProps) {
  return (
    <div className="grid w-full grid-cols-3 gap-4">
      {attachments.map((attachment) => (
        <AttachmentComponent key={attachment?.name} attachment={attachment} />
      ))}
    </div>
  )
}
